import type { ExternalToast } from 'sonner';

export const TOAST_DURATION_MS = 4000;

export const toastTimer = (duration: number): Pick<ExternalToast, 'duration' | 'style'> => ({
	duration,
	style: { '--toast-duration': `${duration}ms` },
});
